// The public surface of the feature-flag module. The raw FEATURE_FLAGS map is
// deliberately NOT re-exported: consumers read through the seam below.
export { isFeatureEnabled, getFeatureFlags } from './feature-flags';
export { useFeatureFlag, useFeatureFlags } from './use-feature-flag';
export type { FeatureFlag } from './flags';
